<template lang="pug">
.custom-radio-button-group-wrapper
  .btn-group(data-toggle="buttons")
    .form-group
      label.control-label
        | {{ label }}

      .d-flex.align-items-center.justify-content-start
        AppRadioButton(
          v-for="item in items"
          :key="item.id"
          :value="item.value"
          :text="item.text"
          :disabled="disabled"
          :selected="isSelected(item)"
          @input="onInput"
        )
</template>

<script>
export default {
  name: 'AppRadioButtonGroup',
  props: {
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    selected: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
  methods: {
    onInput(event) {
      this.$emit('input', event);
    },
    isSelected(item) {
      return this.selected === item.value;
    },
  },
};
</script>
